<script>
  import options from './Overlay.options'
  const componentOptions = options
  export default componentOptions
</script>

<template>
  <dialog class="be-overlay" :class="`${styles ? 'be-overlay--' + styles : ''}`" :data-type="currentOverlayContent" ref="dialogElement">

    <template v-if="currentOverlayContent === OverlayTypes.mainMenu">
      <OverlayMenu :closeTheModal="closeTheModal" :dialogElement="dialogElement"></OverlayMenu>
    </template>

    <template v-else-if="currentOverlayContent === OverlayTypes.prompt">
      <OverlayPrompt :closeTheModal="closeTheModal" :overlayContent="overlayContent" :dialogElement="dialogElement"></OverlayPrompt>
    </template>

    <template v-else-if="currentOverlayContent === OverlayTypes.leadGate">
      <OverlayLeadGate :closeTheModal="closeTheModal" :dialogElement="dialogElement"></OverlayLeadGate>
    </template>

  </dialog>
</template>
